<p class="mb-4">
    {{ getTitle() }}
</p>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>close</button>
</div>
